// The Settings pages a user can open: the SETTINGS part of the nav menu (App.vue navSections) and the rail on the
// settings pages (components/SettingsLayout.vue) both come from here, so they always match
export function settingsLinks(user: any): { to: string, label: string, icon: string }[] {
    if(!user) return [];
    // Standard users: Notifications (Your Alerts for everyone: sign-off reminders, tags; Your Team for managers)
    if(!user.isAdmin) {
        return [ { to: '/notifications', label: 'Notifications', icon: 'bell' } ];
    }
    const links: { to: string, label: string, icon: string }[] = [];
    const link = (to: string, label: string, icon: string) => links.push({ to, label, icon });
    if(user.role == 'Admin') link('/users', 'Admin Users', 'twousers');
    link('/standard-users', 'Standard Users', 'twousers');
    if(user.role == 'Admin') link('/configuration', 'Configuration', 'gear');
    // Every admin user, whatever their role: Your Alerts (any of them can own processes or be tagged), plus Your Team,
    // Company Emails & Texts and so on where those apply
    link('/notifications', 'Notifications', 'bell');
    link('/folders', 'Folders', 'lines');
    if(user.teamHubRole == 'Admin') link('/edit-team-hub-links', 'Edit Links', 'link');
    return links;
}
